import {PageHeader} from "../components/PageHeader";
import {LegalDocument} from "../components/LegalDocument";
import {format, legalPages} from "../i18n";
import {legal} from "../legal";

// Terms for using the website, in src/i18n/en/legal/terms.md. The software itself is governed by its license
// agreement, not these. Update legal.termsEffective with any change.
export function TermsPage() {
    return (
        <div className="legal-text">
            <PageHeader title={legalPages.terms.title} description={legalPages.terms.description}/>
            <p className="text-body-secondary">{format(legalPages.effective, { date: legal.termsEffective })}</p>
            <LegalDocument markdown={legalPages.terms.document} values={legal}/>
        </div>
    );
}
